import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 抑制 Vue Router 3.x 重复导航报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Navigation cancelled')) {
      throw err
    }
  })
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Navigation cancelled')) {
      throw err
    }
  })
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/RegisterPage.vue')
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import('../views/SuccessPage.vue')
  },
  {
    path: '/promoter',
    name: 'PromoterRegister',
    component: () => import('../views/PromoterRegister.vue')
  },
  {
    path: '/share/:code',
    name: 'PromoterShare',
    component: () => import('../views/PromoterShare.vue')
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../views/admin/LoginPage.vue')
  },
  {
    path: '/admin',
    component: () => import('../views/admin/AdminLayout.vue'),
    meta: { requiresAuth: true },
    redirect: '/admin/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/admin/Dashboard.vue')
      },
      {
        path: 'records',
        name: 'Records',
        component: () => import('../views/admin/Records.vue')
      },
      {
        path: 'promoters',
        name: 'Promoters',
        component: () => import('../views/admin/Promoters.vue')
      },
      {
        path: 'join-applications',
        name: 'JoinApplications',
        component: () => import('../views/admin/JoinApplications.vue')
      },
      {
        path: 'config',
        name: 'ConfigPanel',
        component: () => import('../views/admin/ConfigPanel.vue')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫：管理端页面需要 token
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('admin_token')
    if (!token) {
      next('/admin/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
